export default {
  productListGift: 'Gift Settings',
  title: 'Title',
  sku: 'SKU#',
  listing: 'Listing#',
  addDate: 'Add Date',
  giftDate: 'Gift Date',
  giftUsage: 'Manage Gifts',
  giftOption: 'Gift Option',
  all: 'All',
  hasGift: 'Has Gift',
  noGift: 'No Gift',
  giftOnly: 'Gift Only',
  giftSale: 'Gift & Sale',
  saleOnly: 'Sale Only',
  find: 'Find',
  search: 'Search',
  spec: 'SPEC',
  price: 'Price',
  gift: 'Gift',
  sale: 'Sale',
  operation: 'Operation',
  setAsGift: 'Set As Gift',
  usage: 'Usage',
  settingGift: 'Setting Gift',
  settingGifts: 'Setting Gifts',
  option: 'Option',
  settingGiftForListing: 'Setting Gift for Sku#',
  chooseGift: 'Choose Gift',
  productInfo: 'Product Info',
  product: 'Product',
  store: 'Store#',
  name: 'Name',
  creation: 'Creation',
  batchFill: 'Batch Fill',
  per: 'Per',
  promise: 'Promise',
  fill: 'Fill',
  remain: 'Remain',
  period: 'Period',
  alreadyUsed: 'Already Used',
  remove: 'Remove',
  availTillNoGiftStock: 'Avail till No Gift Stock',
  updateOption: 'Update Option',
  filterForSalesItems: 'Filter For Sales Items',
  filterForGifts: 'Filter For Gifts',
  expired: 'Expired?',
  available: 'Available',
  forSalesItem: 'For Sales Item',
  salesItem: 'Sales Item',
  country: 'Country',
  reset: 'Reset',
  brandSelect: 'Brand选择',
  periodSelect: 'Period Select',
  inventory: 'Inventory',
  tip_li1_settings: 'The meaning of the settings for "per/gift/promise" is as follows:',
  tip_li1_per: '"per": Every purchase of [per] items.',
  tip_li1_gift: '"gift": Give [gift] items when [per] items are purchased.',
  tip_li1_promise: '"promise": Total quantity to be given; the gift activity ends when the total quantity has been given away.',
  tip_li2: 'The "Period" refers to the validity period of the gift-giving activity. However, if the promised quantity within the validity period has been exhausted, the current gift-giving activity will also end.',
  tip_li3: 'Checking a particular gift and saving it indicates that this gift is set for the main product\'s gifting activity. Unchecking it means removing this gift from the activity.',
  tip: 'Tip',
  confirmToRemove: 'Confirm to remove?',
  categoryStore: 'Category(Store)',
  giftsStatus: 'Gift Status',
  brand: 'Brand',
  createDate: 'Create Date',
  skuId: 'SKU ID',
  sku2: 'SKU',
  productName: 'Product Name',
  type: 'Type',
  listingId: 'Listing ID',
  availableInventory: 'Available Inventory',
  resetFilter: 'Reset filter',
  salesProductFIlter: 'Sales Product FIlter',
  giftFilter: 'Gift Filter',
  remainQty: 'Remain Qty',
  moreThan0: 'More than 0',
  rules: 'Rules ',
  yes: 'Yes',
  no: 'No',
  salesProduct: 'Sales Product',
  howToSetUpGiftsForProducts: 'How to set up gifts? What is the meaning of parameters like Per/Gift/Promise?',
  howToHandleTheHistorical: 'How to handle the historical gift settings?',
  keepHistoricalGift: 'Keep historical gift settings until all promised quantity sold out or expired',
  cancelAllHistorical: 'Cancel all historical gift settings',
  operateSuccessful: 'Operate Successful',
  pleaseInputGift: 'Please enter the number of items to be given away each time for the gift {0}',
  pleaseInputAwayNumber: 'Please enter the total number of items promised to be given away for the gift {0}',
  pleaseInputGiftTime: 'Please enter the validity period for the gift {0}',
  sendGift: 'Gift'
}
